import { render, staticRenderFns } from "./SelectedItemActions.vue?vue&type=template&id=7b0b0d71"
import script from "./SelectedItemActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedItemActions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports